"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _search = _interopRequireDefault(require("cccisd-icons/svg/search"));
var _chart = _interopRequireDefault(require("cccisd-icons/chart"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var List = function List(props) {
  var search = props.search,
    setSearch = props.setSearch,
    metrics = props.metrics,
    filteredMetrics = props.filteredMetrics,
    currentMetricId = props.currentMetricId,
    setCurrentMetricId = props.setCurrentMetricId;
  var renderSearchButton = function renderSearchButton() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].search
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].icon
    }, /*#__PURE__*/_react["default"].createElement(_search["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Search...",
      name: "search",
      onChange: function onChange(e) {
        return setSearch(e.target.value);
      },
      value: search
    }));
  };
  var renderSearchTotal = function renderSearchTotal() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].searchTotal
    }, "Showing ", filteredMetrics.length, " of ", metrics.length);
  };
  var renderMetricsList = function renderMetricsList() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].metrics
    }, filteredMetrics.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: item.variableId,
        className: (0, _classnames["default"])(_style["default"].metric, currentMetricId === item.variableId && _style["default"].selected),
        onClick: function onClick() {
          return setCurrentMetricId(item.variableId);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].page
      }, "Page ", item.page), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].name
      }, item.reportHeader));
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].title
  }, /*#__PURE__*/_react["default"].createElement(_chart["default"], {
    spaceRight: true
  }), "Visualize"), renderSearchButton(), renderSearchTotal(), renderMetricsList());
};
List.propTypes = {
  search: _propTypes["default"].string,
  setSearch: _propTypes["default"].func,
  metrics: _propTypes["default"].array,
  filteredMetrics: _propTypes["default"].array,
  currentMetricId: _propTypes["default"].number,
  setCurrentMetricId: _propTypes["default"].func
};
List.defaultProps = {};
var _default = List;
exports["default"] = _default;